import { makeRequest, formatDateParam } from "../lib/makeRequest";

export const daily_summary_overall_v3 = (data) => {
  const params = {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  };
  return makeRequest("/daily-transactions/overall", params);
};

export const daily_summary_cluster_v3 = (data) => {
  const params = {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  };
  return makeRequest(`/daily-transactions/cluster/${data.clusterId}`, params);
};

export const daily_summary_area_v3 = (data) => {
  const params = {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  };
  return makeRequest(`/daily-transactions/area/${data.area_code}`, params);
};

export const daily_summary_branch_v3 = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("from", formatDateParam(data.dates.from));
  urlParams.append("to", formatDateParam(data.dates.to));
  return makeRequest(
    `/daily-transactions/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
